import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { FiSearch } from "react-icons/fi";
import config from "../config";

export default function Search() {
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [showResults, setShowResults] = useState(false);
  const [showErro, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const resultRef = useRef(null);

  const handleSearchInputChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();

    if (searchQuery.length < 3) {
      setErrorMessage("لطفاً کلمات درست را وارد نمایید");
      setShowError(true);
      setShowResults(false);
      setTimeout(() => {
        setShowError(false);
        setErrorMessage("");
      }, 5000);
      return;
    }

    // Send a GET request to the PHP backend with the search query
    fetch(
      `${config.apiUrl}contentapi.php?option=1&type=3&subcategory=0&strsearch=${searchQuery}`
    )
      .then((response) => response.json())
      .then((data) => {
        setSearchResults(data);
        setShowResults(true); // Show the results when available
        setShowError(false);

        if (data.length === 0) {
          setErrorMessage("نتیجه‌ای دریافت نشد");
          setShowError(true);
          setShowResults(false);
          setTimeout(() => {
            setShowError(false);
            setErrorMessage("");
          }, 5000);
          return;
        }
      })
      .catch((error) => {
        console.error("Error fetching search results:", error);
        setErrorMessage("Error fetching search results");
        setShowError(true);

        // Hide the response message after 5 seconds
        setTimeout(() => {
          setShowError(false);
          setErrorMessage("");
        }, 5000);
      });
  };

  useEffect(() => {
    const closeDropdown = (e) => {
      if (resultRef.current !== e.target) {
        setShowResults(false);
      }
    };
    document.body.addEventListener("click", closeDropdown);
    return () => document.body.removeEventListener("click", closeDropdown);
  }, []);

  return (
    <div>
      <form
        className="d-flex align-items-center justify-content-center position-relative rounded-2"
        id="search-font"
        role="search"
        onSubmit={handleSearchSubmit}
      >
        <FiSearch
          style={{
            position: "absolute",
            right: "0",
            transform: "translateX(-0.6em)",
          }}
        />
        <input
          className="form-control border-0 w-100"
          style={{
            textIndent: "20px",
            height: "3em",
            borderRadius: "0 4px 4px 0",
          }}
          id="searchInput"
          type="search"
          placeholder="جستجو..."
          aria-label="Search"
          value={searchQuery}
          onChange={handleSearchInputChange}
        />
        <button
          className="secondary-bg-yellow text-white icon-links px-4 py-2 d-flex align-items-center gap-2"
          onClick={() => setShowResults((prev) => !prev)}
          ref={resultRef}
          aria-expanded="false"
          style={{
            position: "relative",
            borderRadius: "4px 0 0 4px",
            border: "4px solid #fff",
          }}
        >
          <img
            src="/img/arrow-w.png"
            style={{ width: "1.2em", rotate: "180deg" }}
            alt=""
          />
          جستجو
        </button>
        {showResults && (
          <ul
            className="position-absolute bg-white top-100 end-0 rounded-1 p-2 d-flex flex-column"
            style={{ zIndex: "2000", rowGap: "1rem" }}
          >
            {searchResults.map((result) => (
              <li key={result.id}>
                <Link
                  className="p-3 blue-links"
                  to={`/${result.CategoryE}/${result.subcategory}/${result.id}`}
                >
                  {result.Title}
                </Link>
              </li>
            ))}
          </ul>
        )}
        {showErro && (
          <ul
            className="position-absolute bg-white top-100 end-0 rounded-1 p-2 d-flex flex-column"
            style={{ zIndex: "2000", rowGap: "1rem" }}
          >
            <li>{errorMessage}</li>
          </ul>
        )}
      </form>
    </div>
  );
}
